import {
    getConnectedAccountUserConfiguration,
    getUserConfiguration,
    isDefaultMailbox,
} from 'owa-session-store';

export function isGroupsEnabled(userIdentity?: string) {
    const userConfiguration =
        !userIdentity || isDefaultMailbox(userIdentity)
            ? getUserConfiguration()
            : getConnectedAccountUserConfiguration(userIdentity);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (8,49): Object is possibly 'undefined'.
    // @ts-expect-error
    return userConfiguration?.GroupsEnabled && !userConfiguration.SessionSettings.IsExplicitLogon;
}
